import { BaseClientConfig } from '@news-mono/web-common'
import React from 'react'
import { AmpAnalytics } from '../analytics'

interface AmpChartbeatProps {
    config: BaseClientConfig
    hostname: string
    sections: string | undefined
    authors: string | undefined
    pathname: string
}

export const AmpChartbeat: React.FC<AmpChartbeatProps> = ({
    config,
    hostname,
    sections,
    authors,
    pathname,
}) => {
    const url = hostname.replace(/^www\./, '')
    const chartbeatConfig = {
        vars: {
            uid: config.chartbeatId,
            domain: url,
            sections: sections || '',
            authors: authors || '',
            canonicalPath: `${url}${pathname.replace(/\.amp$/, '')}`,
        },
    }

    return (
        <AmpAnalytics
            type="chartbeat"
            data-credentials="include"
            dangerouslySetInnerHTML={{
                __html: `
                <script type="application/json">
                    ${JSON.stringify(chartbeatConfig)}
                </script>`,
            }}
        ></AmpAnalytics>
    )
}
